import { useEffect } from "react";

export const useDocumentTitle = (pageTitle?: string) => {
  // Update the document title based on the environment
  const env = import.meta.env.VITE_ENVIRONMENT;
  useEffect(() => {
    document.title = `${env === "local" ? "[LOCAL] " : env === "development" ? "[DEV] " : env === "wip" ? "[WIP] " : ""}${pageTitle ? pageTitle + " | " : ""}Whereabouts`;
  }, [env, pageTitle]);
};
